<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-glass-shop-index">

        <page-title :title="'Szkło'" :back="false"></page-title>

        <div v-if="loading" class="text-center">
            <span class="loader gold"></span>
        </div>

        <div v-if="iframe ? iframe.error : false">
            <p v-if="iframe.message" class="text-center">{{ iframe.message }}</p>
        </div>

        <iframe v-if="iframe ? iframe.url : false"
                id="shopIframe"
                name="shopIframe"
                :src="iframe.url"
                width="100%"
                height="800"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                scrolling="no">
        </iframe>

        <!--<shop-glass-segment :value="'ShopGlass'"></shop-glass-segment>-->

        <!--<div v-for="(item,index) in products" :key="index">-->
            <!--<item-glass-->
                    <!--:index="index"-->
                    <!--:id="item.id"-->
                    <!--:code="item.code"-->
                    <!--:type="item.type"-->
                    <!--:slug="item.slug"-->
                    <!--:price="item.price"-->
                    <!--:priceString="item.priceString"-->
                    <!--:badge="item.badge"-->
                    <!--:name="item.name"-->
                    <!--:description="item.description"-->
                    <!--:image="item.image">-->
            <!--</item-glass>-->
        <!--</div>-->

    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import PageTitle from '@/components/PageTitle.vue';
    import ItemGlass from '@/items/ItemGlass';
    import ShopGlassSegment from '@/navs/ShopGlassSegment';

    export default {
        name: 'ShopGlassIndex',
        components: { PageTitle, ItemGlass, ShopGlassSegment },
        computed: {
            ...mapState({
                loading: state => state.shopGlass.loading,
                iframe: state => state.shopGlass.iframe
            })
        },
        mounted(){
            this.$store.dispatch('profile/PROFILE_REQUEST'); // requested: reload profile
            this.$store.dispatch('shopGlass/SHOP_GLASS_IFRAME_REQUEST').then(() => {
                window.addEventListener('message', this.handleMessage)
            })
        },
        methods: {
            handleMessage(e){
                // handle iframe inner message with simple debounce
                if(this.timeout) clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    let scroll_height = e.data;
                    document.getElementById('shopIframe').style.height = scroll_height + 'px';
                    this.$forceUpdate(); // re-render template
                }, 200);
            }
        },
        beforeDestroy() {
            window.removeEventListener('message', this.handleMessage)
        }
    }
</script>